import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Icon, Input } from "semantic-ui-react";

import "components/UploadImage/UploadImage.scss";
import { useUploadAttachment } from "hooks";
import { clickOnId, isFileWithinSizeLimit } from "utils/common";

type UploadImageProps = {
  path: string;
  baseURL: string;
  onSuccess?: (url: string) => void;
  onError?: (reason: string) => void;
  formId: string;
};

export const UploadImage = ({ path, baseURL, onSuccess, onError, formId }: UploadImageProps) => {
  const { t } = useTranslation();

  const [file, setFile] = useState<File | null>(null);
  const { handleUploadFileAttachment } = useUploadAttachment(path, baseURL);

  const handleChangeFile = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const uploadFile = event.target.files?.[0];
    event.target.value = "";
    if (!uploadFile || !isFileWithinSizeLimit(uploadFile, t)) return;

    const formData = new FormData();
    formData.append(formId, uploadFile);
    setFile(uploadFile);
    try {
      const attachmentUrl = await handleUploadFileAttachment({ formData });

      if (attachmentUrl) onSuccess?.(attachmentUrl);
      else throw new Error(t("v8_something_went_wrong", "Something went wrong, please contact the administrator."));
    } catch (e) {
      const errMessage = e instanceof Error ? e.message : t("v8_something_went_wrong", "Something went wrong, please contact the administrator.");
      if (onError) onError(errMessage);
    }
  };

  const handleDelete = () => {
    const fd = new FormData();
    fd.delete(formId);
    setFile(null);
  };

  return (
    <div className="upload-container">
      <div className="UploadImage new">
        <div className="button" onClick={() => clickOnId(formId)}>
          <p className="btn-text">{t("v8_choose_file", "Choose File")}</p>
        </div>
        <p className="fileInput-ellipsis">{file?.name || t("v8_choose_file", "Choose File")}</p>
      </div>
      <Input id={formId} accept="image/png, image/gif, image/jpeg" type="file" onChange={handleChangeFile} />

      <div className="upload-view">
        {file ? <img alt="preview image" src={URL.createObjectURL(file)} /> : <Icon className="image i-grey" size="huge" />}
        <div className="delete-container" onClick={handleDelete}>
          <Icon className="trash i-grey" />
        </div>
      </div>
    </div>
  );
};
